<script setup>
import AppCard from './ui/AppCard.vue'
import Skeleton from './ui/Skeleton.vue'
</script>

<template>
  <AppCard class="user-skeleton-card">
    <div class="skeleton-top">
      <Skeleton class="avatar" />
      <div class="skeleton-lines">
        <Skeleton class="line title" />
        <Skeleton class="line" />
        <Skeleton class="line short" />
      </div>
    </div>

    <Skeleton class="line" />
    <Skeleton class="line short" />

    <div class="actions">
      <Skeleton class="button" />
      <Skeleton class="button" />
    </div>
  </AppCard>
</template>

<style scoped>
.skeleton-top {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 12px;
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  flex-shrink: 0;
}

.skeleton-lines {
  display: grid;
  gap: 8px;
  flex: 1;
}

.line {
  height: 12px;
}

.title {
  height: 14px;
  width: 65%;
}

.short {
  width: 45%;
}

.actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.button {
  height: 36px;
  width: 96px;
}
</style>

